import React, { useEffect, useState, useRef } from 'react';
import Lottie from "lottie-react";
import killedAnimation from './assets/lottie/kill.json';
import revieAnimation from './assets/lottie/revive.json';
import { Event } from './model/impl/Event';
import './App.css';
import { EventType } from './enum/EventType';
import {
  ArrayQueue,
  ConstantBackoff,
  Websocket,
  WebsocketBuilder,
  WebsocketEvent,
} from "websocket-ts";
import { Converter } from './util/Convertes';
import { QueueCollection } from './model/impl/QueueCollection';
import { Player } from './model/impl/Player';
import { Protection } from './model/impl/Protection';
import { EventsFilter } from './util/EventsFilter';
import { Weapon } from './model/impl/Weapon';
import { Box, Timer, Clan, Heart, Points } from './components';

import Graphic from './assets/images/graphic.png';
import WhiteSkull from './assets/images/whiteSkull.png';
import RedSkull from './assets/images/redSkull.png';
import shield from './assets/images/shield.png';
import bullets from './assets/images/bullets.png';
import medal from './assets/images/medal.png';


function App() {

  const [isDisplayingEvent, setIsDisplayingEVent] = useState(false);
  const [currentEvent, setCurrentEvent] = useState<Event | null>(null);
  const [players, setPlayers] = useState<Player[]>([]);
  const [currentPlayer, setCurrentPlayer] = useState<Player | undefined>(undefined);
  const [protections, setProtections] = useState<Protection[] | undefined>(undefined);
  const [weapons, setWeapons] = useState<Weapon[] | undefined>(undefined);
  const [eventQueue, setEventQueue] = useState<QueueCollection<Event>>(new QueueCollection<Event>());
  const [isPlayerAlive, setIsPlayerAlive] = useState<boolean>(true);
  const kitId = useRef<string | null>(null);
  const missionId = useRef<string | null>(null);


  useEffect(()=>{
    if(isPlayerAlive){
      if(players.length!==0){
        setEventQueue((current) => {
          let ev = new Event('',EventType.REVIVE_EVENT, missionId.current ?? '', 1000);
          ev.kitId=kitId.current ?? '1';
          ev.sourceId='web';
          ev.sourcePath="https://media.tenor.com/KOjqcTw08-wAAAAM/revives-revive.gif";
          current.enqueue(ev);
          console.log("Queue size: " + current.size());
          return current.clone();
        });
      }
      
    }
  },[isPlayerAlive]);

  useEffect(()=>{
    if(currentPlayer?.getIsKilled()){
      setIsPlayerAlive(false);
    }else{
      setIsPlayerAlive(true);
    }
  }, [currentPlayer]);


  /**
   * QUesto effect verrà invocato ad ogni modifica della coda di eventi, perciò sia quando un evento viene aggiunto
   * che quando viene rimosso
   */
  useEffect(() => {
    //Se c'è un evento in stream, non eseguo il processo di update della coda
    if (!isDisplayingEvent) {
      if (eventQueue.size() !== 0) {
        //Seleziono l'evento in testa alla coda
        var eventToDisplay = eventQueue.top();
        if (eventToDisplay !== null) {

          setIsDisplayingEVent(true);
          console.log("streammando evento: " + EventType[eventToDisplay.type]);
          //Setto l'evento corrente in stream
          setCurrentEvent(eventToDisplay);

          //setto un timeout di display dell'evento, una volta temrinato l'evento verrà settato lo state facendo un pop della coda e verrà invocato di nuovo l'effect
          setTimeout(() => {
            setIsDisplayingEVent(false);
            setEventQueue((current) => {
              current.dequeue();
              console.log("Queue size: " + current.size());
              return current.clone();
            });
            //Terminata la stream, setto l'evento corrente a "null"
            setCurrentEvent(null);
          }, 2000);
        }

      }
    }

  }, [eventQueue]);




  useEffect(() => {
    //inizializzazione parametri da query string
    const queryParameters = new URLSearchParams(window.location.search);
    missionId.current = queryParameters.get("missionId");
    kitId.current = queryParameters.get("kitId");

    //inizializzazione connession ws
    //var ws = new WebSocket("wss://mid.rawwar.io/api/events/" + missionId.current + "/" + kitId.current);

    const ws = new WebsocketBuilder("wss://mid.rawwar.io/api/events/" + missionId.current + "/" + kitId.current)
      .withBuffer(new ArrayQueue())           // buffer messages when disconnected
      .withBackoff(new ConstantBackoff(1000)) // retry every 1s
      .build();

    // Function to output & echo received messages
    const echoOnMessage = (i: Websocket, ev: MessageEvent) => {
      console.log(ev.data.toString());
        //converto l'oggetto JSON in un evento tramite il Converter
        var event = Converter.convertToEvent(JSON.parse(ev.data.toString()));

        if (event !== null) {
          //Se l'evento è un kitStatus relativo al kit corrente, aggiorno immediatamente i dati delle protections senza aspettare che l'evento venga processato dalla coda
          if (event.type === EventType.KIT_STATUS_EVENT && event.kitId === kitId.current) { 
            setProtections(event.protections);
            setWeapons(event.weapons);
          }

          /**
           *    if(event.type === EventType.KIT_STATUS_EVENT && event.kitId === kitId.current && event.kitStatus==='alive'){
            setIsPlayerAlive(true);
          }

          if(event.type === EventType.KIT_STATUS_EVENT && event.kitId === kitId.current && event.kitStatus==='dead'){
            setIsPlayerAlive(false);
          }

          if(event.type===EventType.HIT_EVENT && event.kitId===kitId.current && event.isKilled===true){
            setIsPlayerAlive(false);
          }
           */

       

          if(event.players !== undefined){
            setPlayers(event.players);
            var tmpCurrentPlayer=event.players?.find(p => p.getPlayerId()===kitId.current);
            if(tmpCurrentPlayer!==undefined){
              setCurrentPlayer(tmpCurrentPlayer);
            }
          }
          
          //Se l'evento deve essere mostarto in coda, lo aggiungo alla coda degli eventi
          if (EventsFilter.filterEvent(event, kitId.current)) {
            setEventQueue((current) => {
              if (event !== null)
                current.enqueue(event);
              console.log("Queue size: " + current.size());
              return current.clone();
            });
          }
        }
    };

    // Add event listeners
    ws.addEventListener(WebsocketEvent.open, () => console.log("opened!"));
    ws.addEventListener(WebsocketEvent.close, () => console.log("closed!"));
    ws.addEventListener(WebsocketEvent.message, echoOnMessage);
  }, []);

  return (
    <div className='App'>
       {currentEvent?.type===EventType.HIT_EVENT&&currentEvent.isKilled ? <Lottie animationData={killedAnimation}/> : currentEvent?.type===EventType.REVIVE_EVENT ? <Lottie animationData={revieAnimation}/> : <></>}
            <div className='topUI'>
                <div className='innerUI'>
                    <Clan img={WhiteSkull} text='Nome Clan' />
                </div>
                <div className='centerItem'>
                    <Points home={7} opponents={10} />
                </div>
                <div className='innerUI'>
                    <Box text={currentPlayer===undefined ? '0' : currentPlayer.getPoints().toString()} image={WhiteSkull} width={44.6} />
                    <Box text={currentPlayer===undefined ? '0' : currentPlayer.getHits().toString()} image={RedSkull} />
                </div>

            </div>
            <img src={Graphic} className='graphic' />
            <div className='bottomUI'>
                <div className='innerUI'>
                    <Heart life={protections === undefined || currentPlayer?.getIsKilled()===true ? 0 : protections?.length} />
                    <Box text={protections === undefined || currentPlayer?.getIsKilled()===true ? '0' : protections.map(p => p.getProtectionLevel()).reduce((a,b)=> a+b).toString()} image={shield} />
                </div>
                <div className='centerItem'>
                    <Timer minutes={0} seconds={0} />
                </div>
                <div className='innerUI'>
                    <Box text='0' image={bullets} />
                    <Box text='0' image={medal} />
                </div>
               
            </div>
            {/* {
        currentEvent?.type===EventType.HIT_EVENT&&currentEvent.isKilled ? <Lottie animationData={killedAnimation}/> : currentEvent?.type===EventType.REVIVE_EVENT ? <Lottie animationData={revieAnimation}/> : <div></div>
      }
      <h3>Players:</h3>
      <ul>
        {
          players.map(item => {
            return <li>{"Player ID: " + item.getPlayerId() + ", Hits: " + item.getHits() + ", Points: " + item.getPoints() + " , Killed: " + item.getIsKilled()}</li>
          })
        }
      </ul>
      <h3>Protections:</h3>
      <ul>
        {
          protections?.map(protection => {
            return <li>{"Protection Zone: " + protection.getProtectionZone() + ", Protection Type: " + protection.getProtectionType() + ", Protection Level: " + protection.getProtectionLevel()}</li>
          })
        }
      </ul> */}
        </div>
  );
}

export default App;
